/** Shared display helpers for the historical mail archive (mbox) surfaces. */

export const organizationTypeLabel: Record<string, string> = {
  ACADEMIC_GOVERNMENT_NONPROFIT: "大学 / 科研 / 政府 / 非营利",
  ORDINARY_BUSINESS: "普通企业",
  PERSONAL: "个人客户",
};

export const brandLabel: Record<string, string> = {
  benchchem: "BenchChem",
  vulcanchem: "VulcanChem",
  smolecule: "SMolecule",
  evitachem: "EvitaChem",
};

export const availabilityLabel: Record<string, string> = {
  AVAILABLE: "有货",
  NOT_AVAILABLE: "无货",
  TEMPORARILY_UNAVAILABLE: "暂时缺货",
  CUSTOM_SYNTHESIS: "可定制合成",
  PENDING: "待确认",
  UNKNOWN: "未说明",
};

export const hazardStatusLabel: Record<string, string> = {
  DANGEROUS: "历史邮件曾判定为危险品",
  NON_DANGEROUS: "历史邮件判定为非危险品",
  CONFLICTED: "历史证据冲突（既有危险品也有非危险品结论）",
  UNKNOWN: "历史邮件未找到明确判定，不等于安全",
};

/** Short chip text; the full sentence stays next to it as the explanation. */
export const hazardChipLabel: Record<string, string> = {
  DANGEROUS: "曾判为危险品",
  NON_DANGEROUS: "曾判为非危险品",
  CONFLICTED: "历史结论冲突",
  UNKNOWN: "未找到判定",
};

export const transactionStatusLabel: Record<string, string> = {
  PO_RECEIVED: "收到 PO",
  ORDER_CONFIRMED: "订单确认",
  PAYMENT_RECEIVED: "已收款",
};

const confidenceLabel: Record<string, string> = {
  HIGH: "高",
  MEDIUM: "中",
  LOW: "低",
};

export function confidenceName(value: string | null): string {
  return value ? (confidenceLabel[value] ?? "未标注") : "未标注";
}

export function formatMoment(value: string | null): string {
  if (!value) return "未记录";
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return "未记录";
  return parsed.toLocaleString("zh-CN", { hour12: false });
}

export function brandName(value: string | null): string {
  if (!value) return "未标注品牌";
  return brandLabel[value] ?? value;
}

export function formatMoney(
  currency: string | null,
  amount: number | null,
): string {
  if (amount === null) return "未记录价格";
  const formatted = amount.toLocaleString("en-US", {
    maximumFractionDigits: 2,
  });
  return currency ? `${currency} ${formatted}` : formatted;
}

export function archiveGradeLabel(grade: string): string {
  return grade === "UNKNOWN" ? "暂无建议等级" : `${grade} 类`;
}
